import React from "react";

import { useTranslation } from "react-i18next";

import { Icon, IconColor, IconSize } from "@atoms/Icon";

import DataTable from "@components/molecules/DataTable";

import "./PreviewModalTables.scss";

const PreviewModalTables = ({
  afterColumns,
  beforeColumns,
  afterData,
  beforeData
}) => {
  const { t } = useTranslation();

  return (
    <div className="preview-modal-tables">
      <DataTable
        title={t(
          "common:ui.websheet.actions.cleaningWizard.step.preview.before.label"
        )}
        columns={beforeColumns}
        hideHeaders={true}
        data={beforeData}
      />
      {
        <Icon
          name="keyboard_arrow_right"
          color={IconColor.ACCENT}
          size={IconSize.L}
        />
      }
      <DataTable
        title={t(
          "common:ui.websheet.actions.cleaningWizard.step.preview.after.label"
        )}
        hideHeaders={true}
        columns={afterColumns}
        data={afterData}
      />
    </div>
  );
};
export default PreviewModalTables;
